import apiClient from '../api/apiClient';

export const enquiryService = {
  getEnquiryList: async (params) => {
    return apiClient.post('/v1/enquiries/search', params);
  },
  getEnquiryDetails: async (id) => {
    return apiClient.get(`/v1/enquiries/${id}`);
  },
  createEnquiry: async (data) => {
    return apiClient.post('/v1/enquiries', data);
  },
  updateEnquiry: async (id, data) => {
    return apiClient.put(`/v1/enquiries/${id}`, data);
  },
  deleteEnquiry: async (id) => {
    return apiClient.delete(`/v1/enquiries/${id}`);
  },
  addFollowUp: async (data) => {
    return apiClient.post('/v1/enquiries/followup', data);
  },
  getFollowUps: async (id) => {
    return apiClient.get(`/v1/enquiries/${id}/followups`);
  }
};
